import { render } from "./Prepayment.vue?vue&type=template&id=74688d11&scoped=true&ts=true"
import script from "./Prepayment.vue?vue&type=script&lang=ts"
export * from "./Prepayment.vue?vue&type=script&lang=ts"

import "./Prepayment.vue?vue&type=style&index=0&id=74688d11&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74688d11"]])

export default __exports__